import Modal from './Modal';


function OAuthModalMicrosoft() {
  return (
    <Modal>
      <div className="flex flex-col items-center justify-center gap-8 bg-white" style={{ width: "600px", height: "400px" }}>
        <div className="text-2xl text-center font-gilroy font-bold">Microsoft Requires Popups</div>
        <div className="flex flex-col gap-4 text-gray-400 w-4/5">
          If you can't see a Microsoft File Picker window right now, you might have popups blocked. Please enable popups to use the Microsoft integration and try again.
        </div>
      </div>
    </Modal>
  );
}

export default OAuthModalMicrosoft;
